<template>
    <v-container fluid style="max-width: 720px">
        <h2 class="text-h6 mb-1">Azienda</h2>
        <div class="text-body-2 text-medium-emphasis mb-4">Dati anagrafici e logo della tua azienda</div>

        <v-card class="mb-4" variant="outlined">
            <v-card-title>Logo</v-card-title>
            <v-card-text>
                <div class="d-flex align-center" style="gap: 20px">
                    <v-avatar size="80" rounded="lg" color="grey-lighten-3">
                        <v-img v-if="logoUrl" :src="logoUrl" cover />
                        <v-icon v-else size="36" color="grey">mdi-domain</v-icon>
                    </v-avatar>
                    <div class="flex-grow-1">
                        <v-file-input v-model="fileLogo" label="Carica logo (jpg, png, webp)" accept="image/*"
                            density="compact" variant="outlined" hide-details prepend-icon="mdi-image"
                            :loading="caricandoLogo" @update:model-value="caricaLogo" />
                        <v-btn v-if="logoUrl" size="small" variant="text" color="error" class="mt-2"
                            :loading="rimuovendoLogo" @click="rimuoviLogo">
                            Rimuovi logo
                        </v-btn>
                    </div>
                </div>
                <div class="text-caption text-medium-emphasis mt-2">
                    Visibile in fondo al menu laterale.
                </div>
            </v-card-text>
        </v-card>

        <v-card variant="outlined">
            <v-card-title>Dati aziendali</v-card-title>
            <v-card-text>
                <v-form ref="formRef">
                    <v-text-field v-model="form.ragioneSociale" label="Ragione sociale" class="mb-4"
                        :rules="[v => !!v || 'Obbligatorio']" />
                    <v-text-field v-model="form.partitaIva" label="Partita IVA" class="mb-4" />
                    <v-text-field v-model="form.indirizzo" label="Sede legale" class="mb-4" />
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.email" label="Email" type="email" />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.telefono" label="Telefono" />
                        </v-col>
                    </v-row>
                </v-form>

                <v-divider class="my-4" />

                <div class="text-caption text-medium-emphasis mb-1">Piano e abbonamento (gestiti dal gestore del servizio)</div>
                <div class="d-flex align-center" style="gap: 12px">
                    <v-chip size="small" variant="tonal">{{ dati?.piano || '—' }}</v-chip>
                    <v-chip size="small" :color="dati?.attivo ? 'success' : 'error'" variant="flat">
                        {{ dati?.attivo ? 'Attivo' : 'Disattivato' }}
                    </v-chip>
                    <span v-if="dati?.dataScadenza" class="text-caption text-medium-emphasis">
                        Scadenza: {{ formattaData(dati.dataScadenza) }}
                    </span>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-alert v-if="messaggio" type="success" density="compact" variant="tonal" class="mr-2 py-1">
                    {{ messaggio }}
                </v-alert>
                <v-btn color="primary" :loading="salvando" @click="salva">Salva</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: "MiaAziendaPage",

    data() {
        return {
            form: { ragioneSociale: "", partitaIva: "", indirizzo: "", email: "", telefono: "" },
            salvando: false,
            messaggio: "",
            fileLogo: null,
            caricandoLogo: false,
            rimuovendoLogo: false,
        };
    },

    computed: {
        dati() {
            return this.$store.getters["miaAzienda/dati"];
        },
        logoUrl() {
            return this.$store.getters["miaAzienda/logoUrl"];
        },
    },

    async mounted() {
        try {
            await this.$store.dispatch("miaAzienda/carica");
            await this.$store.dispatch("miaAzienda/caricaLogo");
        } catch (error) {
            console.log(error);
        }
        if (this.dati) {
            this.form = {
                ragioneSociale: this.dati.ragioneSociale,
                partitaIva: this.dati.partitaIva,
                indirizzo: this.dati.indirizzo,
                email: this.dati.email,
                telefono: this.dati.telefono,
            };
        }
    },

    methods: {
        formattaData(iso) {
            return new Date(iso).toLocaleDateString("it-IT");
        },

        async salva() {
            if (!this.$refs.formRef.validate()) return;
            this.messaggio = "";
            this.salvando = true;
            try {
                await this.$store.dispatch("miaAzienda/salva", { ...this.form });
                this.messaggio = "Dati aggiornati.";
            } catch (error) {
                console.log(error);
            }
            this.salvando = false;
        },

        async caricaLogo(file) {
            if (!file) return;
            this.caricandoLogo = true;
            try {
                await this.$store.dispatch("miaAzienda/uploadLogo", file);
            } catch (error) {
                console.log(error);
            }
            this.fileLogo = null;
            this.caricandoLogo = false;
        },

        async rimuoviLogo() {
            this.rimuovendoLogo = true;
            try {
                await this.$store.dispatch("miaAzienda/eliminaLogo");
            } catch (error) {
                console.log(error);
            }
            this.rimuovendoLogo = false;
        },
    },
};
</script>
